import { useEffect, useRef } from 'react';
import { Game } from '../../shared/api/client';
import { subscribeToGame } from '../../shared/api/socket';

type GameUpdateCallback = (game: Game) => void;

/**
 * Hook to subscribe to game updates via WebSocket.
 * Used to detect when game version settings change and trigger a reload.
 */
export function useGameUpdates(
  gameId: string | undefined,
  onGameUpdate: GameUpdateCallback
) {
  const callbackRef = useRef(onGameUpdate);

  // Keep callback ref up to date
  useEffect(() => {
    callbackRef.current = onGameUpdate;
  }, [onGameUpdate]);

  useEffect(() => {
    if (!gameId) {
      return;
    }

    let unsubscribe: (() => void) | null = null;

    subscribeToGame(gameId, (data) => {
      console.log('Received game update:', gameId);
      callbackRef.current(data.game as Game);
    }).then((unsub) => {
      unsubscribe = unsub;
    }).catch((err) => {
      console.error('Failed to subscribe to game updates:', err);
    });

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [gameId]);
}
